export default __webpack_public_path__ + "static/text-hero-browser-475c1042059f39197ea0c7ba599c27d4.png";